import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_ConsentReleaseInfo = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_ConsentReleaseInfo' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Consent to Release/Obtain Information</h3></p>

                <p className='w-750'>
                    I hereby give my consent/permission for &nbsp;
                    <input placeholder='Agency Name' type='text' id='txtAgencyName' name='txtAgencyName' className='add-only w-350 custom-add-only' />
                </p>
                <p className='w-750'>
                    <textarea id='txtAgencyAddress' placeholder='Agency Address' name='txtAgencyAddress' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbReleaseInformation' name='cbReleaseInformation' className='add-only' value='ReleaseInformation' />
                    <b>To release information to:</b>
                </p>
                <p className='w-750'>
                    <textarea id='txtReleaseInformationNameAddress' placeholder='Agency/Person Name/Title and Address' name='txtReleaseInformationNameAddress' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <input type='checkbox' id='cbObtainInformation' name='cbObtainInformation' className='add-only' value='ObtainInformation' />
                    <b>To obtain information from:</b>
                </p>
                <p className='w-750'>
                    <textarea id='txtObtainInformationNameAddress' placeholder='Agency/Person Name/Title and Address' name='txtObtainInformationNameAddress' className='add-only'></textarea>
                </p>
                <p className='w-750'><span className='eleHeader'>For the specific purpose of:</span></p>
                <p className='w-750'>
                    <input type='checkbox' id='cbTreatment' name='cbTreatment' className='add-only' value='Treatment' />Treatment
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbCoordinationServices' name='cbCoordinationServices' className='add-only' value='CoordinationServices' />Coordination of Services
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='Other' />Other: &nbsp;
                    <input type='text' id='txtOther' name='txtOther' className='add-only w-350 custom-add-only' />

                </p>
                <p className='w-750'>
                    <span className='eleHeader'>The extent and nature of the information to be disclosed/obtained must be indicated :</span>
                    <span className='small'>(check all that apply):</span>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_1' name='cbNatureOfInformation_1' className='add-only' value='NatureOfInformation_1' /> Evaluations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_2' name='cbNatureOfInformation_2' className='add-only' value='NatureOfInformation_2' /> Progress Notes
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_3' name='cbNatureOfInformation_3' className='add-only' value='NatureOfInformation_3' /> Substance Abuse Records
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_4' name='cbNatureOfInformation_4' className='add-only' value='NatureOfInformation_4' /> Contact Summaries
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_5' name='cbNatureOfInformation_5' className='add-only' value='NatureOfInformation_5' /> Identifying Information
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_6' name='cbNatureOfInformation_6' className='add-only' value='NatureOfInformation_6' /> Diagnosis/Prognosis/Recommendations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_7' name='cbNatureOfInformation_7' className='add-only' value='NatureOfInformation_7' /> Psychiatric Records
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_8' name='cbNatureOfInformation_8' className='add-only' value='NatureOfInformation_8' /> Admission/ Discharge Summary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_9' name='cbNatureOfInformation_9' className='add-only' value='NatureOfInformation_9' /> Activity Support Plan Individual Service Plan/ Plan of Services &
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_10' name='cbNatureOfInformation_10' className='add-only' value='NatureOfInformation_10' /> Supports
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNatureOfInformation_11' name='cbNatureOfInformation_11' className='add-only' value='NatureOfInformation_11' /> Other: &nbsp;
                            <input type='text' id='txtNatureOfInformation_11' name='txtNatureOfInformation_11' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><hr /></p>

                <p className='w-750'>
                    I understand that I may revoke this consent at any time except to the extent that action has been taken.
                    I further understand that this consent will expire upon
                </p>

                <p className='w-750'>
                    <input placeholder='(Specific Date/Event/Condition)' type='text' id='txtSpecificDateEventCondition' name='txtSpecificDateEventCondition' className='add-only' />
                </p>
                <p className='w-750'>
                    and cannot be renewed without my consent.I understand that to revoke this authorization,Individual
                    or Legal Representative must provide a written request and the revocation will not apply to action or
                    information that has already been released/obtained in response to this authorization. Any information obtained
                    as a result of this release is confidential. State and federal laws and regulations prohibit any entity receiving
                    confidential information from redistributing the information to any other entity without the specific written consent
                    of the person to whom it pertains or as otherwise permitted by law and regulations. I understand the information I
                    authorize for release may include informationrelated to history/diagnosis and/or treatment of HIV, AIDS, communicable
                    or sexually transmitted diseases and alcohol/drug abuse or dependency.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    I understand that confidential information maybe released without my consent when necessary for
                    continued services; when release is necessary for the determination of eligibility for benefits,
                    compliance with statutory reporting requirements, or other lawful purpose; if you communicate to
                    the treating physician, psychologist, master social worker or licensed professional counselor an
                    actual threat of physical violence against a clearly identified or reasonably identifiable potential
                    victim or victims; in compliance with reporting requirements under state law of incidents of suspected
                    child abuse or neglect or by court order.
                </p>
                <p className='w-750'><hr /></p>
                <p className='w-750'>
                    <b>By signing below, I acknowledge receipt of a copy of the signed authorization</b>
                </p>


            </div>
        </form >

    )
}











